import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import { CATALOG_MENUS } from '@/utils/constants';
import SummaryContent from './summary-content/summary-content';
import ActivityContent from './activity-content/activity-content';
import { tree } from 'd3';

@Component({
    name: 'content-loader',
    components: {
        SummaryContent,
        ActivityContent,
    },
})

export default class ContentLoder extends Vue {

    // ----------------------------------------------
    // Properties

    @Prop()
    public contentType: any;

    @Prop()
    private filterParams: any;

    private catalogMenus: any = [];

    private activeComponent: any = {};

    @Watch('catalogMenus', {deep: true})
    private onChange(value: any) {
        this.activeComponent =  value.find((item: any) => item.isActive);
    }

    // ------------------------------------------------------------------
    // Hooks
    private created() {
        if (this.$access.isCapLibrary) {
            CATALOG_MENUS[0].isActive = false;
            CATALOG_MENUS[0].isDisabled = true;
            CATALOG_MENUS[CATALOG_MENUS.length - 1].isActive = true;
        }
        this.catalogMenus = CATALOG_MENUS;
    }


    private onSelectTenantCard() {
        this.$emit('onSelectTenantCard');
    }

}
